export const GET_MODEL_MOCK_RESPONSE = externalPortfolioId => {
	return {
		success: true,
		errors: null,
		status: 'OK',
		response: {
			portfolioId: externalPortfolioId
		}
	};
};

export const GET_MODEL_LIST_MOCK_RESPONSE = {
	success: true,
	errors: null,
	status: 'OK',
	response: [
		{
			portfolioId: 'apm1b41daee1-fcf2-4ee0-a562-af2a064fd58e',
			name: 'APM One Valid and One Substituted'
		},
		{
			portfolioId: 'apm3b41daee1-fcf2-4ee0-a562-af2a064fd58e',
			name: 'APM Single Asset Class Substitution'
		},
		{
			portfolioId: 'apm2b41daee1-fcf2-4ee0-a562-af2a064fd58e',
			name: 'APM Two Substituted Asset Class'
		},
		{
			portfolioId: '4a754d63-da68-483c-a4db-ee06e338cb15-apm-clean',
			name: 'APM Clean Portfolio'
		},
		{
			portfolioId: 'b41daee1-fcf2-4ee0-a562-af2a064fd58e',
			name: 'APM Dirty Sleeve Portfolio'
		},
		{
			portfolioId: '4a754d63-da68-483c-a4db-ee06e338cb15',
			name: 'APM Dirty Security Portfolio'
		},
		{
			portfolioId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-clean',
			name: 'UMA Clean Portfolio'
		},
		{
			portfolioId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-dirty',
			name: 'UMA Dirty Portfolio'
		},
		{
			portfolioId: '27adfa87-ecd4-47f9-b64a-ea411d1e752b-uma-reimport',
			name: 'UMA Reimported Portfolio'
		},
		{
			portfolioId: 'ba38c5fc-0fa4-41d4-a7a2-1f5af20e8a20',
			name: 'UMA BLK Test New Model 1'
		},
		{
			portfolioId: '741f35d0-a64e-45be-bb4a-230bd5068c9f',
			name: 'APM Duplicate Identifier Test'
		},
		{
			portfolioId: '8662006f-1626-4bdd-94f9-4cdbd4e1e7f6',
			name: 'APM Duplicate Asset Class to One ETF Test'
		},
		{
			portfolioId: '7480d077-89a1-417a-88ad-e604578457b9',
			name: 'APM One Fixed Income Substitution'
		},
		{
			portfolioId: 'f547dacc-9675-40a0-a795-c7cd295f6d11',
			name: 'APM One default CASH swap'
		},
		{
			portfolioId: '529d304c-8074-459d-a9fa-fcce897e0989',
			name: 'OLD APM Dirty'
		},
		{
			portfolioId: '49c05b8c-534d-41f2-869d-09ca165a26f3',
			name: 'OLD APM Dirty 2'
		}
	]
};

export const CREATE_UPDATE_MODEL_MOCK_RESPONSE_INVALID = {
	success: true,
	errors: null,
	status: 'OK',
	response: {
		portfolioId: null,
		portfolioJsonData: null,
		modelValidationResult: {
			status: 'ERROR',
			results: [
				{
					code: 'security.not.eligible',
					message: 'Security is not eligible; Not an approved security',
					status: 'ERROR',
					violatingObject: {
						type: 'security',
						value: {
							ticker: 'ADBE',
							cusip: '00724F101'
						}
					}
				}
			]
		}
	}
};

export const GET_ALL_CLIENTS_MOCK_RESPONSE = {};

export const GET_PROGRAM_HANDLES_MOCK_RESPONSE = {
	success: true,
	errors: null,
	status: 'OK',
	response: [
		{
			programHandle: '1~16~11',
			programName: 'Separate Accounts',
			programTypeId: 2,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '0.00'
		},
		{
			programHandle: '1~16~12',
			programName: 'Guided Portfolios Program',
			programTypeId: 1,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '10000.00'
		},
		{
			programHandle: '1~16~140',
			programName: 'Fixed Immediate Annuity',
			programTypeId: 8,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '10000.00'
		},
		{
			programHandle: '1~16~95',
			programName: 'Variable Annuities',
			programTypeId: 8,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '10000.00'
		},
		{
			programHandle: '1~16~114',
			programName: 'Unified Managed Household',
			programTypeId: 7,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '100000.00'
		},
		{
			programHandle: '1~16~306',
			programName: 'Digital Advice',
			programTypeId: 1,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '10000.00'
		},
		{
			programHandle: '1~16~101',
			programName: 'Unified Managed Account',
			programTypeId: 6,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '150000.00'
		},
		{
			programHandle: '1~16~10',
			programName: 'Mutual Fund & Exchange Traded Fund Portfolios',
			programTypeId: 1,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '2000.00'
		},
		{
			programHandle: '1~16~58',
			programName: 'Reporting Only',
			programTypeId: 10,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '0.00'
		},
		{
			programHandle: '1~16~13',
			programName: 'Advisor as Portfolio Manager',
			programTypeId: 4,
			minimumInvestmentCurrencySecurityHandle: '1~11~263467',
			minimumInvestmentCurrencyCode: 'USD',
			minimumInvestmentAmount: '5000.00'
		}
	]
};

export const GET_RISK_SCALES_MOCK_RESPONSE = {
	success: true,
	errors: null,
	status: 'OK',
	response: [
		{
			handle: '1~33~18',
			maximumRiskScore: 14,
			minimumRiskScore: 1,
			name: 'Capital Preservation'
		},
		{
			handle: '1~33~19',
			maximumRiskScore: 29,
			minimumRiskScore: 15,
			name: 'Conservative'
		},
		{
			handle: '1~33~20',
			maximumRiskScore: 43,
			minimumRiskScore: 30,
			name: 'Conservative Growth'
		},
		{
			handle: '1~33~21',
			maximumRiskScore: 57,
			minimumRiskScore: 44,
			name: 'Moderate'
		},
		{
			handle: '1~33~22',
			maximumRiskScore: 71,
			minimumRiskScore: 58,
			name: 'Moderate Growth'
		},
		{
			handle: '1~33~23',
			maximumRiskScore: 86,
			minimumRiskScore: 72,
			name: 'Growth'
		},
		{
			handle: '1~33~24',
			maximumRiskScore: 100,
			minimumRiskScore: 87,
			name: 'Aggressive Growth'
		}
	]
};

export const SAMPLE_EXPORT_WITH_INVALID_DATA_FROM_WTP_RESPONSE = {
	errors: null,
	response: {
		portfolioId: 'd094949f-fe96-4477-9c63-41ad04bc041d',
		portfolioJsonData: {
			'@type': 'ToolsResultBeans',
			allDataReturned: true,
			bmsRequestTime: 580,
			errorCodes: ['INVALID_DATA'],
			requestId: 'DTTS-time-20190916_08-25-26_214_env-TSTDMZ_hkey-tsz02_count-15220',
			requestTime: 243,
			requests: [
				{
					'@type': '_bws.request.user.UserDataEditRequest',
					apiClient: 'bfm'
				}
			],
			resultLength: 1793,
			resultMap: {
				SEARCH_EDIT_RESULTS: [
					{
						'@type': '_bws.search.SearchEditResults',
						debugMessage: 'No existing data found for uniqueId [d094949f-fe96-4477-9c63-41ad04bc041d] and allowedCreateIfMissing is set to false',
						errorCodes: ['INVALID_DATA'],
						missing: ['d094949f-fe96-4477-9c63-41ad04bc041d'],
						resultList: [],
						success: false,
						total: 0
					}
				]
			},
			serverNumber: 1,
			success: false,
			timerLogs: {
				retrieveData: 242,
				solrRealTimeGet: 242,
				cleanData: 0,
				resultPostProcess: 0
			},
			totalRequestTime: 823
		}
	},
	responseTimes: {
		root: {
			nodes: [
				{
					data: {
						accessToken: 0.001
					}
				},
				{
					data: {
						updatePortfolio: 0.85
					}
				}
			]
		}
	},
	status: 'OK',
	success: true
};

export const SAMPLE_GET_MODEL_RESPONSE = {
	success: true,
	errors: null,
	status: 'OK',
	response: {
		portfolioId: 'ee2400e5-44ff-4da7-8486-e8ce8461b576',
		portfolioJsonData: {
			'@type': 'ToolsResultBeans',
			allDataReturned: true,
			bmsRequestTime: 8,
			requestId: 'DTTS-time-20190502_11-49-20_424_env-TSTDMZ_hkey-tzcw02_count-10031',
			requests: [
				{
					'@type': '_bws.request.user.UserDataEditRequest',
					apiClient: 'envestnet',
					requestId: 'DTTS-time-20190502_11-49-20_424_env-TSTDMZ_hkey-tzcw02_count-10031',
					requestingApp: 'webtools',
					requestUser: {
						'@type': '_bws.user.SimpleUser',
						aladdinPerms: { PortBuilderSec: ['WithholdExpRet'] },
						apiClient: 'envestnet',
						secondaryApiClients: ['env_tst', 'env_tstdmz', 'env@tstdmz', 'env@tst'],
						trackingId: '2544719',
						userEmail: 'portfoliomanagement@envestnet.com',
						userId: 'portfoliomanagement@envestnet.com',
						userPlatformId: '3173638'
					},
					secondaryApiClients: ['env_tst', 'env_tstdmz', 'env@tstdmz', 'env@tst'],
					timeout: 60,
					useCache: true,
					user: 'portfoliomanagement@envestnet.com',
					datas: [
						{
							'@type': '_bws.user.WebUserData',
							currentUserIsOwner: true,
							date: 1556797760424,
							trackingType: 'userData',
							uniqueId: 'ee2400e5-44ff-4da7-8486-e8ce8461b576',
							userEmail: 'portfoliomanagement@envestnet.com',
							userId: 'portfoliomanagement@envestnet.com',
							children: [
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: '76b52771-24b5-45e2-a943-a9fd87ccd76a',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'VWOB@921946885',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'VWOB@921946885',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'Vanguard Emerging Mkts Govt Bd ETF', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: '921946885', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN0111065040HRLT5M6T4CXU5XWKVOWDBP6N54M7ODAA6MVAW6LYIKWO7J4MC3SJQ===='
										},
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'VWOB', identifierType: 'TICKER' }
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.08
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'e70ade56-1e42-4fac-ab29-6d295347e10b',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'IEFA@46432F842',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'IEFA@46432F842',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'iShares Core MSCI EAFE', type: 'SECURITY' },
									otherIdentifiers: [
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN011961911H6QZSXLREPTQFU4BH3E3XQZLTVIMKKPZG4KOIPCEKJLH5K7LCBVNQ===='
										},
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'IEFA', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '46432F842', identifierType: 'CUSIP' }
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.07
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'c3577bbe-943f-40db-a1fe-5ecd7047589e',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'PONPX@72201M719',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'PONPX@72201M719',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'PIMCO Income I2', type: 'SECURITY' },
									otherIdentifiers: [
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN011261529HFWYC2DM2PK7XU3RJAYU4BQQIYWDDYAF7PCMOLRPBYG25RNHH6QRA===='
										},
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'PONPX', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '72201M719', identifierType: 'CUSIP' }
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.13
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'bc704418-0fda-4f70-ab5d-fe4f1abb3761',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'IEMG@46434G103',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'IEMG@46434G103',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'iShares Core MSCI Emerging Markets ETF', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: '46434G103', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN011937481H6ANJC44QBNABFG6GZJEJG2B5DDHJPJAOY4UJ3OFQAIVR3J5OH5DQ===='
										},
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'IEMG', identifierType: 'TICKER' }
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.05
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'ebcb07aa-d045-43cb-ab52-44a00ab748d8',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'MTUM@46432F396',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'MTUM@46432F396',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'iShares Edge MSCI USA Momentum Fctr ETF', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'MTUM', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '46432F396', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN0111048146HRLT5M6T4CXU5XWKVOWDBP6N54MD3OWWK5CCRFJ3D7TCCROTXNWJA===='
										}
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.07
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'b0d28932-8243-492c-9d2b-a705c167deab',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'AGTHX@399874106',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'AGTHX@399874106',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'American Funds Growth Fund of Amer A', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: '399874106', identifierType: 'CUSIP' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'AGTHX', identifierType: 'TICKER' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN0117978H6AUY5PXA2W6T5CEVOCLXHDKZ3S4R3LDIZQDQ26ENZOCJRYTAPXGQ===='
										}
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.02
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'f4270992-b712-4c1e-9dea-ec1e0c2913f1',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'IVV@464287200',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'IVV@464287200',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'iShares Core S&P 500', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'IVV', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '464287200', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN01112384HMP3DTXTWEFTTWOOP5OXDP5HCNGCCSDKXQ4CGT774Q4GW3O3IVIJQ===='
										}
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.25
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: '57f046ea-7abb-44e4-845e-8af15efc84d3',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'DBLTX@258620103',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'DBLTX@258620103',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'DoubleLine Total Return Bond I', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: '258620103', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN011333818HVBBSLNWSSF64NHGXGDO6KFRV2OEWH7TXIKD5NYPTFSLALWEWVUPQ===='
										},
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'DBLTX', identifierType: 'TICKER' }
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.03
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: 'c1ea6e00-cfe0-4077-885b-89dcb1c3810c',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'VO@922908629',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'VO@922908629',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'Vanguard Mid-Cap ETF', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'VO', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '922908629', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN011721HWCAW4ANJMG6TVRGWEBZVJCRMU2H6XPSCUU4MTP4WUVTUVBNPSPMA===='
										}
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.09
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: '7a252a95-644c-4007-9c94-717a843979ca',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'LQD@464287242',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'LQD@464287242',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'iShares iBoxx $ Investment Grade Corporate Bond ETF', type: 'SECURITY' },
									otherIdentifiers: [
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'LQD', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '464287242', identifierType: 'CUSIP' },
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN01113117HXNVBU6ZCGSDKK6PV44NYWQOAEFXMRIMD6NJAHPBP7YNUUFKBGS5Q===='
										}
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.16
								},
								{
									'@type': '_bws.user.WebUserData',
									currentUserIsOwner: true,
									date: 1556797760424,
									trackingType: 'userData',
									uniqueId: '787e7e82-cdb9-40fe-a222-cf820de3fcf9',
									userEmail: 'portfoliomanagement@envestnet.com',
									userId: 'portfoliomanagement@envestnet.com',
									commonIdentifier: 'VB@922908751',
									commonIdentifierType: 'SECURITY_ID',
									dateCreated: 1556797760424,
									dateLastModified: 1556797760424,
									identifier: 'VB@922908751',
									identifierType: 'SECURITY_ID',
									originPlatform: { name: 'Vanguard Small-Cap ETF', type: 'SECURITY' },
									otherIdentifiers: [
										{
											'@type': '_bws.investments.IdentifierParam',
											customIdentifierType: 'ENVESTNET_HANDLE',
											identifier: '0100000EEEN01134409HHWZTUFUVF3ME3DDKU4JT6ECAK7G4KZG4BYDPVDEMCE2JN7QRKP3A===='
										},
										{ '@type': '_bws.investments.IdentifierParam', identifier: 'VB', identifierType: 'TICKER' },
										{ '@type': '_bws.investments.IdentifierParam', identifier: '922908751', identifierType: 'CUSIP' }
									],
									owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
									positionType: 'VALID',
									type: 'PORTFOLIO_POSITION',
									updateUserId: 'portfoliomanagement@envestnet.com',
									userPlatformId: '3173638',
									userTrackingId: '2544719',
									weight: 0.05
								}
							],
							dateCreated: 1556797760424,
							dateLastModified: 1556797760424,
							flags: { inputWithValues: false, originContainsUnmatchedSecurities: false, originContainsAssetClassSubstitutions: false },
							originPlatform: { dateImported: '1556797760401', platform: 'ENVESTNET', unmatchedSecuritiesStrategy: 'MAPPED', firm: 'demof' },
							otherIdentifiers: [
								{
									'@type': '_bws.investments.IdentifierParam',
									customIdentifierType: 'ENVESTNET_HANDLE',
									identifier: '0100000EEEN015532868HDV7J3WDAHF64RDKQHE7GB4LJ47T6DJEIDGPDD3MLKJH467HAWQLQ===='
								}
							],
							owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
							subType: 'THIRD_PARTY_MODEL',
							type: 'PORTFOLIO',
							updateUserId: 'portfoliomanagement@envestnet.com',
							userPlatformId: '3173638',
							userTrackingId: '2544719'
						}
					]
				}
			],
			requestTime: 1596,
			resultLength: 33766,
			serverNumber: 1,
			success: true,
			timerLogs: {
				editData: 3,
				validate: 0,
				prepareFields: 0,
				addData: 1590,
				adlIndexRequest: 1584,
				'adl.findChildren': 39,
				'adl.preProcess': 5,
				'adl.addData': 1537,
				cleanData: 0,
				resultPostProcess: 0
			},
			totalRequestTime: 1604,
			resultMap: {
				SEARCH_EDIT_RESULTS: [
					{
						'@type': '_bws.search.SearchEditResults',
						success: true,
						resultList: [
							{
								'@type': 'com.bfm.webtools.api.domain.user.WebUserData',
								currentUserIsOwner: true,
								date: 1556797760424,
								trackingType: 'userData',
								uniqueId: 'ee2400e5-44ff-4da7-8486-e8ce8461b576',
								userEmail: 'portfoliomanagement@envestnet.com',
								userId: 'portfoliomanagement@envestnet.com',
								children: [
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: '76b52771-24b5-45e2-a943-a9fd87ccd76a',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'VWOB@921946885',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'VWOB@921946885',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'Vanguard Emerging Mkts Govt Bd ETF', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: '921946885', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN0111065040HRLT5M6T4CXU5XWKVOWDBP6N54M7ODAA6MVAW6LYIKWO7J4MC3SJQ===='
											},
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'VWOB', identifierType: 'TICKER' }
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.08
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'e70ade56-1e42-4fac-ab29-6d295347e10b',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'IEFA@46432F842',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'IEFA@46432F842',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'iShares Core MSCI EAFE', type: 'SECURITY' },
										otherIdentifiers: [
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN011961911H6QZSXLREPTQFU4BH3E3XQZLTVIMKKPZG4KOIPCEKJLH5K7LCBVNQ===='
											},
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'IEFA', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '46432F842', identifierType: 'CUSIP' }
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.07
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'c3577bbe-943f-40db-a1fe-5ecd7047589e',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'PONPX@72201M719',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'PONPX@72201M719',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'PIMCO Income I2', type: 'SECURITY' },
										otherIdentifiers: [
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN011261529HFWYC2DM2PK7XU3RJAYU4BQQIYWDDYAF7PCMOLRPBYG25RNHH6QRA===='
											},
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'PONPX', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '72201M719', identifierType: 'CUSIP' }
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.13
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'bc704418-0fda-4f70-ab5d-fe4f1abb3761',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'IEMG@46434G103',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'IEMG@46434G103',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'iShares Core MSCI Emerging Markets ETF', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: '46434G103', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN011937481H6ANJC44QBNABFG6GZJEJG2B5DDHJPJAOY4UJ3OFQAIVR3J5OH5DQ===='
											},
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'IEMG', identifierType: 'TICKER' }
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.05
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'ebcb07aa-d045-43cb-ab52-44a00ab748d8',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'MTUM@46432F396',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'MTUM@46432F396',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'iShares Edge MSCI USA Momentum Fctr ETF', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'MTUM', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '46432F396', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN0111048146HRLT5M6T4CXU5XWKVOWDBP6N54MD3OWWK5CCRFJ3D7TCCROTXNWJA===='
											}
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.07
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'b0d28932-8243-492c-9d2b-a705c167deab',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'AGTHX@399874106',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'AGTHX@399874106',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'American Funds Growth Fund of Amer A', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: '399874106', identifierType: 'CUSIP' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'AGTHX', identifierType: 'TICKER' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN0117978H6AUY5PXA2W6T5CEVOCLXHDKZ3S4R3LDIZQDQ26ENZOCJRYTAPXGQ===='
											}
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.02
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'f4270992-b712-4c1e-9dea-ec1e0c2913f1',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'IVV@464287200',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'IVV@464287200',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'iShares Core S&P 500', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'IVV', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '464287200', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN01112384HMP3DTXTWEFTTWOOP5OXDP5HCNGCCSDKXQ4CGT774Q4GW3O3IVIJQ===='
											}
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.25
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: '57f046ea-7abb-44e4-845e-8af15efc84d3',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'DBLTX@258620103',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'DBLTX@258620103',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'DoubleLine Total Return Bond I', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: '258620103', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN011333818HVBBSLNWSSF64NHGXGDO6KFRV2OEWH7TXIKD5NYPTFSLALWEWVUPQ===='
											},
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'DBLTX', identifierType: 'TICKER' }
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.03
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: 'c1ea6e00-cfe0-4077-885b-89dcb1c3810c',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'VO@922908629',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'VO@922908629',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'Vanguard Mid-Cap ETF', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'VO', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '922908629', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN011721HWCAW4ANJMG6TVRGWEBZVJCRMU2H6XPSCUU4MTP4WUVTUVBNPSPMA===='
											}
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.09
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: '7a252a95-644c-4007-9c94-717a843979ca',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'LQD@464287242',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'LQD@464287242',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'iShares iBoxx $ Investment Grade Corporate Bond ETF', type: 'SECURITY' },
										otherIdentifiers: [
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'LQD', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '464287242', identifierType: 'CUSIP' },
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN01113117HXNVBU6ZCGSDKK6PV44NYWQOAEFXMRIMD6NJAHPBP7YNUUFKBGS5Q===='
											}
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.16
									},
									{
										'@type': '_bws.user.WebUserData',
										currentUserIsOwner: true,
										date: 1556797760424,
										trackingType: 'userData',
										uniqueId: '787e7e82-cdb9-40fe-a222-cf820de3fcf9',
										userEmail: 'portfoliomanagement@envestnet.com',
										userId: 'portfoliomanagement@envestnet.com',
										commonIdentifier: 'VB@922908751',
										commonIdentifierType: 'SECURITY_ID',
										dateCreated: 1556797760424,
										dateLastModified: 1556797760424,
										identifier: 'VB@922908751',
										identifierType: 'SECURITY_ID',
										originPlatform: { name: 'Vanguard Small-Cap ETF', type: 'SECURITY' },
										otherIdentifiers: [
											{
												'@type': '_bws.investments.IdentifierParam',
												customIdentifierType: 'ENVESTNET_HANDLE',
												identifier: '0100000EEEN01134409HHWZTUFUVF3ME3DDKU4JT6ECAK7G4KZG4BYDPVDEMCE2JN7QRKP3A===='
											},
											{ '@type': '_bws.investments.IdentifierParam', identifier: 'VB', identifierType: 'TICKER' },
											{ '@type': '_bws.investments.IdentifierParam', identifier: '922908751', identifierType: 'CUSIP' }
										],
										owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
										positionType: 'VALID',
										type: 'PORTFOLIO_POSITION',
										updateUserId: 'portfoliomanagement@envestnet.com',
										userPlatformId: '3173638',
										userTrackingId: '2544719',
										weight: 0.05
									}
								],
								dateCreated: 1556797760424,
								dateLastModified: 1556797760424,
								flags: { inputWithValues: false, originContainsUnmatchedSecurities: false, originContainsAssetClassSubstitutions: false },
								originPlatform: { dateImported: '1556797760401', platform: 'ENVESTNET', unmatchedSecuritiesStrategy: 'MAPPED', firm: 'demof' },
								otherIdentifiers: [
									{
										'@type': '_bws.investments.IdentifierParam',
										customIdentifierType: 'ENVESTNET_HANDLE',
										identifier: '0100000EEEN015532868HDV7J3WDAHF64RDKQHE7GB4LJ47T6DJEIDGPDD3MLKJH467HAWQLQ===='
									}
								],
								owner: { userEmail: 'portfoliomanagement@envestnet.com', userPlatformId: '3173638', userId: 'portfoliomanagement@envestnet.com' },
								subType: 'THIRD_PARTY_MODEL',
								type: 'PORTFOLIO',
								updateUserId: 'portfoliomanagement@envestnet.com',
								userPlatformId: '3173638',
								userTrackingId: '2544719'
							}
						],
						allLoaded: ['ee2400e5-44ff-4da7-8486-e8ce8461b576'],
						originalsLoaded: ['ee2400e5-44ff-4da7-8486-e8ce8461b576'],
						total: 12
					}
				]
			}
		}
	},
	responseHeaders: null
};
